import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { string, oneOf, func } from 'prop-types';
import { Button, Overlay } from '@thd-olt-component-react/core-ui';
import { useLayoutGroupProps } from '@thd-olt-component-react/layout-manager';
import { VirtualAssistanceTooltip } from './VirtualAssistanceTooltip';
import { ProductAddOnsPod } from '../../common/product-add-ons-pod';
import { virtualAssistanceContactInformation } from '../../../utils/product-add-on-constants';
import { useTippyToggle } from '../../../hooks/useTippyToggle';
import styles from './virtual-assistance.scss';

const VirtualAssistance = (props) => {
  const {
    channel,
    itemId,
    onChange
  } = props;
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const tooltipButtonRef = useTippyToggle(checked);
  const buttonURL = '/services/i/doorswindows-dp-tv/b66b6826d/form?flow=the_home_depot_product_email';

  const cx = classNames.bind(styles);
  const classes = cx(
    'product-add-ons__request-appointment',
    { 'u--hide': !checked }
  );

  const { mvaTestA = true } = useLayoutGroupProps({ props });
  const handleChange = (evt) => {
    LIFE_CYCLE_EVENT_BUS.trigger('virtual-assistance.change', { isOptedIn: !checked, itemId });
    onChange({
      itemId,
      checked: evt.target.checked,
      addOnType: evt.target.value
    });
    setChecked(!checked);
  };

  const [mvaTestB, setMvaTestB] = useState(false);

  const displayModal = () => {
    setOpen(true);
  };

  useEffect(() => {
    const tippy = tooltipButtonRef?.current?._tippy;
    if (tippy && !checked) tippy.hide();
  }, [checked]);

  useEffect(() => {
    if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('virtual-assistance.mvaTestA', { mvaTestA });
    }
  }, [mvaTestA]);

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.on('virtual-consulting.mvaTestB', (data) => {
      setMvaTestB(data.output.mvaTestB);
    });
  }, []);

  const ContactInformation = () => (
    <div className={cx('virtual-assistance__install-text')}>Or call
      <span className={cx('u__default-link')}> 1-833-HD-APRON
        <a
          href={`tel:${virtualAssistanceContactInformation.help_fast_contact.tel}`}
        >
          <span>({virtualAssistanceContactInformation.help_fast_contact.label})</span>
        </a>
      </span>
    </div>
  );

  const subHeading = (
    <div>
      Speak to a Virtual Associate about Doors or Windows today.
      <span className={cx(channel === 'desktop' && 'va-subheading')}> Available from 9 am - 8 pm EST.</span>
    </div>
  );

  if (!mvaTestA && !mvaTestB) return null;

  return (
    <div className="virtual-assistance-addon">
      <ProductAddOnsPod
        channel={channel}
        heading="Have Questions? We're Here to Help."
        subHeading={subHeading}
        icon="apron.svg"
        iconHeight={channel === 'desktop' ? 70 : 44}
        iconWidth={channel === 'desktop' ? 75 : 48}
        onChange={handleChange}
        tooltipOptional={channel === 'mobile' && (
          <VirtualAssistanceTooltip
            channel={channel}
            ref={tooltipButtonRef}
          />
        )}
        userOptions={[
          {
            id: 'item ID',
            value: 'virtual-assistance',
            checked,
            label: 'Request Appointment'
          }
        ]}
      >
        <Button
          className={classes}
          outline={false}
          onClick={displayModal}
        >
          Request Appointment
        </Button>
        {
          (channel === 'mobile' || (channel === 'desktop')) && (
            <div className={cx('virtual-assistance__information')}><ContactInformation />
              {channel === 'desktop' && (
                <span className={cx('virtual-assistance__tooltip')}><VirtualAssistanceTooltip
                  channel={channel}
                  ref={tooltipButtonRef}
                />
                </span>
              )}
            </div>
          )
        }
      </ProductAddOnsPod>
      <Overlay onClose={() => setOpen(false)} open={open} medium closeButton>
        <iframe title="Request Appointment" src={buttonURL} width="100%" height="99%" />
      </Overlay>
    </div>
  );
};

VirtualAssistance.displayName = 'ProductAddOns-VirtualAssistance';

VirtualAssistance.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf(['desktop', 'mobile']),
  itemId: string.isRequired,
  onChange: func.isRequired
};

VirtualAssistance.defaultProps = {
  channel: 'desktop',
};

export { VirtualAssistance };